import { render, staticRenderFns } from "./N3AdvancedStats.vue?vue&type=template&id=c04b6438&scoped=true"
import script from "./N3AdvancedStats.vue?vue&type=script&lang=js"
export * from "./N3AdvancedStats.vue?vue&type=script&lang=js"
import style0 from "./N3AdvancedStats.vue?vue&type=style&index=0&id=c04b6438&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04b6438",
  null
  
)

export default component.exports